import { render } from "./NotfoundView.vue?vue&type=template&id=5b689a86&scoped=true"
import script from "./NotfoundView.vue?vue&type=script&lang=js"
export * from "./NotfoundView.vue?vue&type=script&lang=js"

import "./NotfoundView.vue?vue&type=style&index=0&id=5b689a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b689a86"]])

export default __exports__